import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { TimePicker, Checkbox } from 'antd';

import { convertirTextAMomentUTC } from '../../commons/gestioDates';
import moment from 'moment';

const VALOR_VARIABLE_HORA_SI_SHA_OBSERVAT_MES_DUN_COP = '99:99';
const MASCARA_HORA_VISUALITZAR_TIMEPICKER = 'HH:mm';

/**
 * Retorna true si s'ha de deshabilitar el componet. Que es deshabiliti el component depen de:
 *      - si no es pot editar
 *      - que s'hagi observat més d'un cop (també es deshabilita)
 *
 * @param {Object} variable
 * @param {*} valor
 * @return {boolen}
 */
const shaDeDeshabilitarComponent = (variable, valor) => {
    //Si no esta informat el camp "variable.esPotEditar" vol dir que SI es pot editar
    const { esPotEditar, esValorCalculAutomatic } = variable;
    const esNoEditable = (typeof (esPotEditar) === 'undefined') ? false : !esPotEditar;
    const shaObservatMesDunCop = shaObservatMesDeUnCop(variable, valor);

    return shaObservatMesDunCop || esNoEditable || esValorCalculAutomatic;
};

const shaObservatMesDeUnCop = (variable, valor) => {
    return (valor !== VALOR_VARIABLE_HORA_SI_SHA_OBSERVAT_MES_DUN_COP) ? false : true;
};

class ObservacioIntroduccioVariableHora extends Component {

    constructor(props) {
        super(props);
        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
    }

    onChangeCheckBox(id, valorCheckbox) {
        const valorTimePickerText = this.componentTimePicker.state.value ? this.componentTimePicker.state.value.format(MASCARA_HORA_VISUALITZAR_TIMEPICKER) : null;
        const valor = valorCheckbox.target.checked ? VALOR_VARIABLE_HORA_SI_SHA_OBSERVAT_MES_DUN_COP : valorTimePickerText;
        this.props.onChangeValorVariable(id, valor);
    }

    render() {
        const variable = this.props.variable;
        const valor = variable.hasOwnProperty('valorNou') ? variable.valorNou : variable.valor;
        var variableValor = (valor && (valor !== VALOR_VARIABLE_HORA_SI_SHA_OBSERVAT_MES_DUN_COP)) ? convertirTextAMomentUTC(valor, MASCARA_HORA_VISUALITZAR_TIMEPICKER) : null;

        return (
            <div className="observacio-introduccio-variable">
                <span className="observacio-introduccio-variable-nom-hora" >
                    {variable.nomVariable}
                </span>

                <span>
                    <TimePicker
                        placeholder={MASCARA_HORA_VISUALITZAR_TIMEPICKER}
                        defaultValue={variableValor}
                        defaultOpenValue={moment('00:00', MASCARA_HORA_VISUALITZAR_TIMEPICKER)}
                        format={MASCARA_HORA_VISUALITZAR_TIMEPICKER}
                        onChange={(time) => { this.props.onChangeValorVariable(time ? time.format(MASCARA_HORA_VISUALITZAR_TIMEPICKER) : null); }}
                        ref={(timepicker) => { this.componentTimePicker = timepicker; }}
                        disabled={shaDeDeshabilitarComponent(variable, valor)}
                    />
                    &nbsp;UTC
                    {variable.unitats}
                    <Checkbox
                        className='text-variables-tipus-hora'
                        style={{ marginLeft: '20px' }}
                        defaultChecked={shaObservatMesDeUnCop(variable, valor)}
                        onChange={(valor) => { this.onChangeCheckBox(variable.idEstacioVariableMoment, valor); }}>
                        {'S\'ha observat en diverses hores'}
                    </Checkbox>
                </span>
            </div>
        );
    }
}

ObservacioIntroduccioVariableHora.propTypes = {
    variable: PropTypes.object,
    onChangeValorVariable: PropTypes.func,
};

export default ObservacioIntroduccioVariableHora;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioVariableHora.js